<template>
  <div class="history-mobile-container">
    <!-- 顶部导航栏 -->
    <div class="header-bar">
      <div class="left" @click="$router.go(-1)">
        <i class="el-icon-arrow-left" />
        <span>历史记录</span>
      </div>
      <div class="right" @click="clearHistory">
        <i class="el-icon-delete" /> 清空
      </div>
    </div>

    <!-- 历史记录列表 -->
    <div v-if="historyList.length > 0" class="history-list">
      <div
        v-for="(item, index) in historyList"
        :key="item.videoId + '_' + index"
        class="history-card"
        @click="openVideo(item)"
      >
        <div class="cover-box">
          <img :src="item.coverUrl" class="cover-img" alt="cover">
          <span class="orientation-tag">
            <i :class="item.horizontal ? 'el-icon-monitor' : 'el-icon-mobile-phone'" />
          </span>
          <span v-if="item.durationStr" class="duration-tag">{{ item.durationStr }}</span>
        </div>
        <div class="info-box">
          <h4 class="title">{{ item.title }}</h4>
          <div class="sub-info">
            <span class="author">{{ item.user ? item.user.screenName : '匿名UP主' }}</span>
            <span v-if="item.progress" class="progress-text">看到 {{ item.progress }}</span>
          </div>
        </div>
        <div class="delete-btn" @click.stop="removeItem(index)">
          <i class="el-icon-close" />
        </div>
      </div>

      <!-- 底部加载更多按钮 -->
      <div class="load-more-wrap">
        <el-button
          v-if="hasNext"
          type="text"
          :loading="loading"
          @click="loadMore"
        >
          {{ loading ? '加载中...' : '点击加载更多' }}
        </el-button>
        <div v-else class="no-more">没有更多历史记录了</div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-else-if="!loading" class="empty-state">
      <i class="el-icon-time" />
      <p>还没有任何历史记录哦~</p>
    </div>
  </div>
</template>

<script>
import { getVisitRecord } from '@/api/vod'

export default {
  name: 'MyHistoryMobile',
  data() {
    return {
      nextId: 0,
      hasNext: true,
      loading: false,
      historyList: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.loading || !this.hasNext) return
      this.loading = true

      getVisitRecord(this.nextId).then(resp => {
        if (resp.code === 0) {
          const { list, nextId } = resp.data
          this.historyList = [...this.historyList, ...(list || [])]
          this.nextId = nextId
          this.hasNext = (list && list.length > 0)
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loading = false
      })
    },
    loadMore() {
      this.getData()
    },
    openVideo(item) {
      this.$router.push(`/video/${item.videoId}`)
    },
    removeItem(index) {
      this.historyList.splice(index, 1)
      this.$message.success('已删除该条历史记录')
    },
    clearHistory() {
      this.$confirm('确定要清空所有历史记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.historyList = []
        this.hasNext = false
        this.$message.success('历史记录已清空')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.history-mobile-container {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-top: 50px;
  padding-bottom: 30px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.header-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    cursor: pointer;
    i { font-size: 18px; }
  }

  .right {
    font-size: 13px;
    color: #909399;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.history-list {
  padding: 12px;

  .history-card {
    display: flex;
    align-items: center;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
    position: relative;
    cursor: pointer;

    .cover-box {
      position: relative;
      width: 110px;
      height: 70px;
      border-radius: 6px;
      overflow: hidden;
      flex-shrink: 0;
      margin-right: 12px;
      background-color: #f0f0f0;

      .cover-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .orientation-tag {
        position: absolute;
        top: 4px;
        left: 4px;
        background-color: rgba(0, 0, 0, 0.6);
        color: #ffffff;
        font-size: 10px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        i { font-size: 11px; }
      }

      .duration-tag {
        position: absolute;
        bottom: 4px;
        right: 4px;
        background: rgba(0, 0, 0, 0.7);
        color: #ffffff;
        font-size: 9px;
        padding: 1px 4px;
        border-radius: 2px;
      }
    }

    .info-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 70px;
      padding-right: 10px;
      overflow: hidden; /* 防止内容溢出容器 */

      .title {
        font-size: 13px;
        font-weight: 500;
        color: #303133;
        margin: 0;
        line-height: 1.35;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 最多显示2行，超出显示省略号 */
        -webkit-box-orient: vertical;
        word-break: break-all; /* 防止长英文/数字不换行 */
      }

      .sub-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 11px;
        color: #909399;
        margin-top: 4px;

        .author {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap; /* 单行不换行 */
          max-width: 55%;     /* 限制最大宽度，防止挤压右侧进度 */
        }

        .progress-text {
          color: #409eff;
          white-space: nowrap;
          flex-shrink: 0;   /* 防止进度文字被压缩 */
        }
      }
    }

    .delete-btn {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #c0c4cc;
      font-size: 16px;
      padding: 6px;
      cursor: pointer;
    }
  }

  .load-more-wrap {
    text-align: center;
    padding: 15px 0;
    font-size: 13px;
    color: #909399;

    .no-more {
      font-size: 12px;
      color: #c0c4cc;
    }
  }
}

.empty-state {
  text-align: center;
  padding-top: 100px;
  color: #909399;

  i {
    font-size: 48px;
    margin-bottom: 10px;
    color: #dcdfe6;
  }
  p {
    font-size: 14px;
    margin: 0;
  }
}
</style>
